import React, { useEffect, useState } from 'react';
import { Form, Modal, Input, Button, Checkbox, Table, Space, Upload, message, Image, Select, Typography, Row, Col } from 'antd';
import { FileAddOutlined, UserAddOutlined } from '@ant-design/icons';
import { cpuUsage } from 'process';
import { getCurrentUser, listUser } from '../services/User';
import { API_PREFIX } from '../config';
import { Delete, Get, Post } from '../utils/request';
import { Header } from 'antd/lib/layout/layout';
import Title from 'antd/lib/typography/Title';
import { getFixHeader } from '../utils/request';

const valueRenderer = (cell: any, i: number, j: number) => {
    return cell.value;

}
const dataRenderer = (cell: any) => {
    return cell.value
}
const onContextMenu = (e: any, cell: any, i: any, j: any) =>
    cell.readOnly ? e.preventDefault() : null;

const onCellsChanged = (changes: any) => {
}
const Log = () => {
    const [data, setData] = useState<any>([]);
    const moment = require("moment");
    const [pageInfo, setPageInfo] = useState<any>({ total: 0, pageSize: 40, page: 1 });
    const columns = [
        {
            title: '操作员',
            dataIndex: 'operator',
            key: 'operator'
        },
        {
            title: '操作内容',
            dataIndex: 'content',
            key: 'content'
        },
        {
            title: '日期',
            dataIndex: 'updateAt',
            key: 'updateAt',
            render: (text: any, record: any) => (
                new moment(text).format("YYYY-MM-DD HH:mm:ss")

            ),
        }
    ];

    const pagination = {
        total: pageInfo.total,
        page: pageInfo.page,
        pageSize: pageInfo.pageSize,
        showTotal: (total: number) => {
            return `总数:${total}`;
        },

        onChange: async (page: number, pageSize: number) => {

        }
    }

    const udpate = () => {
        const reqUrl = `${API_PREFIX}/summary`
        console.log("v1", reqUrl)
        Get(`/log`, null).then((v) => {
            // const data = v.data;
            setData(v.data)
        }).catch((e) => {
            console.log("error", e)
        });

    }
    useEffect(() => {
        udpate()

        // const grid = [
        //     [{ value: 5 }, { value: 6 }]]

        // setData(grid)
    }, [])

    const clear = () => {
        Modal.confirm({
            title: "提示",
            content: "确定要清理掉所有日志吗？",
            okText:"确定",
            cancelText:"取消",
            onOk: () => {
                Delete("/log").then(() => {
                    udpate()
                })
            }
        })


    }


    return <div style={{ margin: 0 }}>
        <h2 className='title'>日志管理</h2>
        <Row>
            <Col span={24}>
                <Button type="primary" danger onClick={clear}>清理</Button>
            </Col>
        </Row>
        <Row>
            <Col span={24}>
                <Table dataSource={data} pagination={pagination} columns={columns} />
            </Col>
        </Row>

    </div>

};

export default Log;